import { CloseSubmitProps, Modal } from '../Modal';
import { useApi } from '../../hooks/useApi';
import { useFormValue } from '../../hooks/useFormValue';
import {
  CreateTransactions,
  TransactionType,
  transactionTypeOptions,
} from '../../model/Transaction';
import { Form } from '../form/Form';
import { Select } from '../form/Select';
import { today } from '../../utils/date';
import { useState } from 'react';
import { Certificate } from '../../model/Certificate';
import { Button } from '../form/Button';
import { Input } from '../form/Input';

export interface Props extends CloseSubmitProps {
  memberId: number;
}

const transactionTypeResult: Record<TransactionType, string> = {
  buy: 'gekocht',
  sell: 'verkocht',
  gift: 'gegift',
};

export const CreateTransactionsModal = ({
  onClose,
  onSubmit,
  memberId,
}: Props) => {
  const api = useApi();
  const [transactions, setField] = useFormValue<
    Omit<CreateTransactions, 'memberId'>
  >(() => ({
    type: 'buy',
    amount: 1,
    date: today(),
  }));
  const [affectedCerts, setAffectedCerts] = useState<Certificate[]>();

  return (
    <Modal title="Nieuwe transacties" onClose={onClose}>
      {affectedCerts ? (
        <>
          <h3>
            {affectedCerts.length} certificaten{' '}
            {transactionTypeResult[transactions.type]}:
          </h3>
          <div>{affectedCerts.map((c) => c.fullName).join(', ')}</div>
          <Button text="Sluiten" onClick={onClose} className="actions" />
        </>
      ) : (
        <Form
          className="rows"
          submitLabel="Opslaan"
          onSubmit={() =>
            api.transactions
              .createTransactions({ ...transactions, memberId })
              .then(setAffectedCerts)
              .then(() => onSubmit())
          }
        >
          <div>
            <label>Type</label>
            <Select
              value={transactions.type}
              onChange={setField('type')}
              required
              options={transactionTypeOptions}
            />
          </div>
          <div>
            <label>Certificaten</label>
            <Input
              type="number"
              value={transactions.amount}
              onChange={setField('amount')}
              required
              min={1}
              step={1}
            />
          </div>
          <div>
            <label>Datum</label>
            <Input
              type="date"
              value={transactions.date}
              onChange={setField('date')}
              required
            />
          </div>
        </Form>
      )}
    </Modal>
  );
};
